import { makeMultiCurrencyFetchKey, makeMultiCurrencyFetchUrl } from 'framework-data-schema-quick-fetch';
import { withQuickFetch } from '../quickFetch/withQuickFetch';
export const fetchPortalCurrencies = ({
  httpClient
}) => withQuickFetch({
  requestName: makeMultiCurrencyFetchKey({}),
  baseFetch: () => httpClient.get(makeMultiCurrencyFetchUrl())
});